export const localStorageHelper = {
  setItem: (key: string, value: string) => {
    const appName = import.meta.env.VITE_APP_NAME || 'defaultAppName';
    const storageKey = `${appName}-${key}`;
    localStorage.setItem(storageKey, value);
  },

  getItem: (key: string): string | null => {
    const appName = import.meta.env.VITE_APP_NAME || 'defaultAppName';
    const storageKey = `${appName}-${key}`; 
    return localStorage.getItem(storageKey);
  },

  removeItem: (key: string) => {
    const appName = import.meta.env.VITE_APP_NAME || 'defaultAppName';
    const storageKey = `${appName}-${key}`;
    localStorage.removeItem(storageKey);
  }
};
